module.exports = __webpack_public_path__ + "static/media/tda-logo-desktop-black.fc593193.png";